<template>
    <div class="column content-box">
      <woot-modal-header
        :header-title="$t('CADENCIAS.FORM.TITLE')"
        :header-content="
          useInstallationName(
            $t('CADENCIAS.FORM.DESC'),
            globalConfig.installationName
          )
        "
      />
      <cadencia-form
        :value="value"
        :is-submitting="uiFlags.creatingItem"
        @submit="onSubmit"
        @cancel="onClose"
      />
    </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';
import { mapGetters } from 'vuex';
import CadenciaForm from './CadenciaForm';

export default {
  components: {
    CadenciaForm,
  },
  mixins: [alertMixin, globalConfigMixin],
  props: {
    value: {
      type: Object,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      globalConfig: 'globalConfig/get',
      uiFlags: 'cadencias/getUIFlags',
    }),
  },
  methods: {
    async onSubmit(cadencia) {
      try {
        await this.$store.dispatch('cadencias/update', {
          cadencia,
          id: this.id,
        });
        this.showAlert(
          this.$t('CADENCIAS.EDIT.API.SUCCESS_MESSAGE')
        );
        this.onClose();
      } catch (error) {
        const message =
          error.response?.data?.message ||
          this.$t('CADENCIAS.EDIT.API.ERROR_MESSAGE');
        this.showAlert(message);
      }
    },
  },
};
</script>